/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { adminv3_AsyncRequestItemResponse } from "../models/adminv3_AsyncRequestItemResponse"
import type { adminv3_AsyncRequestResponse } from "../models/adminv3_AsyncRequestResponse"
import type { adminv3_AsyncRequestStatusSummaryResponse } from "../models/adminv3_AsyncRequestStatusSummaryResponse"
import type { avy_api_internal_avyframework_avyhttp_ListRequest } from "../models/avy_api_internal_avyframework_avyhttp_ListRequest"
import type { avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestItemResponse } from "../models/avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestItemResponse"
import type { avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestResponse } from "../models/avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestResponse"

import type { CancelablePromise } from "../core/CancelablePromise"
import { OpenAPI } from "../core/OpenAPI"
import { request as __request } from "../core/request"

export class AsyncRequestService {
    /**
     * List async request items
     * List async request items with filtering and pagination
     * @returns avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestItemResponse OK
     * @throws ApiError
     */
    public static postV3AdminAsyncRequestItemList({
        request,
    }: {
        /** Async request item list request **/
        request: avy_api_internal_avyframework_avyhttp_ListRequest
    }): CancelablePromise<avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestItemResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/async-request/item/list",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Get async request item
     * Get a specific async request item by ID
     * @returns adminv3_AsyncRequestItemResponse OK
     * @throws ApiError
     */
    public static getV3AdminAsyncRequestItem({
        id,
    }: {
        /** Async Request Item ID **/
        id: number
    }): CancelablePromise<adminv3_AsyncRequestItemResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v3/admin/async-request/item/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * List async requests
     * List async requests with filtering and pagination
     * @returns avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestResponse OK
     * @throws ApiError
     */
    public static postV3AdminAsyncRequestList({
        request,
    }: {
        /** Async request list request **/
        request: avy_api_internal_avyframework_avyhttp_ListRequest
    }): CancelablePromise<avy_api_internal_avyframework_avyhttp_ListResponse_adminv3_AsyncRequestResponse> {
        return __request(OpenAPI, {
            method: "POST",
            url: "/v3/admin/async-request/list",
            body: request,
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Get async request status summary
     * Get aggregated status counts for async requests
     * @returns adminv3_AsyncRequestStatusSummaryResponse OK
     * @throws ApiError
     */
    public static getV3AdminAsyncRequestStatusSummary({
        dateFrom,
        dateTo,
    }: {
        /** Filter from date (RFC3339 format) **/
        dateFrom?: string
        /** Filter to date (RFC3339 format) **/
        dateTo?: string
    }): CancelablePromise<Array<adminv3_AsyncRequestStatusSummaryResponse>> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v3/admin/async-request/status-summary",
            query: {
                date_from: dateFrom,
                date_to: dateTo,
            },
            errors: {
                400: `Bad Request`,
                500: `Internal Server Error`,
            },
        })
    }

    /**
     * Get async request
     * Get a specific async request by ID
     * @returns adminv3_AsyncRequestResponse OK
     * @throws ApiError
     */
    public static getV3AdminAsyncRequest({
        id,
    }: {
        /** Async Request ID **/
        id: number
    }): CancelablePromise<adminv3_AsyncRequestResponse> {
        return __request(OpenAPI, {
            method: "GET",
            url: "/v3/admin/async-request/{id}",
            path: {
                id: id,
            },
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        })
    }
}
